import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, Input } from '@angular/core';
import { ListService } from '../../../../../../shared/services/list.service';
import { UserService } from '../../../../../../services/user.service';
import { TableModule } from 'primeng/table';
import { FieldsetModule } from 'primeng/fieldset';
import { Subscription } from 'rxjs';
import { LookupService } from '../../../../../../services/lookup.service';

@Component({
    selector: 'ppl-invoice-edit-history-view',
    templateUrl: './invoice-edit-history-view.component.html',
    styleUrls: ['./invoice-edit-history-view.component.css'],
    standalone: true,
    imports: [
        TableModule,
        FieldsetModule
    ],
})
export class InvoiceEditHistoryViewComponent implements OnInit, OnDestroy {

    @Input() invoiceLineId!: number;
    invoiceEditHistoryData: any[] = [];
    private programName!: string;
    private listDataSub!: Subscription;
    groupedInvoiceEditHistoryData: any[] = [];
    dispositionReason: any[] = [];
    invoiceDisposition: any[] = [];


    constructor(
        private listService: ListService,
        private userService: UserService,
        private lookupService: LookupService
    ) {
    }

    ngOnInit(): void {
        const selectedProgram = this.userService.getSelectedProgram();
        this.dispositionReason = this.lookupService.getLookupValue('Disposition Reason');
        this.invoiceDisposition = this.lookupService.getLookupValue('TimeSheet Disposition');
        this.programName = selectedProgram?.program_code ?? '';
        this.getInvoiceEditHistory();
    }

    getInvoiceEditHistory() {
        const payload: any = {
            pageName: 'invoice-processCode-history',
            programCode: this.programName,
            condition: 'and',
            recordsPerPage: 20,
            startingPageNumber: 1,
            searchParam: [
                {
                jsonPath: 'invoiceId',
                value: this.invoiceLineId,
                operator: 'Equal',
                },
            ],
            orderByColumn: [],
            orderBy: ['desc'],
        }
        if (!this.invoiceLineId) {
            return;
        }
        this.listDataSub = this.listService.getListData(payload, 'claims').subscribe(data => {
            const responseData = data?.responsedata;
            this.invoiceEditHistoryData = responseData || [];
            this.invoiceEditHistoryData.forEach((e: any) => {
                if (e.reasonLkp) {
                    e.reason = this.dispositionReason.filter((d: any) => d.lkpValueCode == e.reasonLkp)[0].lkpValueName;
                }

                if (e.dispositionLkp) {
                    e.disposition = this.invoiceDisposition.filter((d: any) => d.lkpValueCode == e.dispositionLkp)[0].lkpValueName
                }
            });
            this.groupByRunDate();
        })
    }

    groupByRunDate() {
        const groupedByRunDate = this.invoiceEditHistoryData.reduce((acc, item) => {
        const key = item.runDate ?? null;
        if (!acc[key]) {
            acc[key] = { runDate: item.runDate, items: [] as any[] };
        }
            acc[key].items.push(item);
            return acc;
        }, {} as Record<string, { runDate: string; items: any[] }>);

        const groupedArray = Object.values(groupedByRunDate);
        this.groupedInvoiceEditHistoryData = groupedArray;
    }

    ngOnDestroy(): void {
        if (this.listDataSub) {
            this.listDataSub.unsubscribe();
        }
    }
}